import { Button } from "@/components/ui/button";
import { useNewVersionCheck } from "@/hooks/useNewVersionCheck";

/**
 * Non-blocking "new version available" notice (#917). Mounted once at the app
 * root, inside the router. Rendered after the cookie banner at the same
 * z-index, so it sits on top of it; dialogs (portalled later) still cover it.
 */
export const NewVersionBanner = () => {
  const { newVersion, reload } = useNewVersionCheck();

  if (newVersion === null) {
    return null;
  }

  return (
    <div
      role="status"
      className="fixed inset-x-4 bottom-4 z-50 mx-auto flex max-w-md flex-wrap items-center gap-x-4 gap-y-2 rounded-lg border bg-background p-4 text-sm text-foreground shadow-lg"
    >
      <p className="min-w-0 flex-1">A new version of the portal is available.</p>
      <Button type="button" size="sm" onClick={reload}>
        Reload
      </Button>
    </div>
  );
};
